// splash.tsx

import React, { useEffect } from "react"
import { View, StyleSheet, Dimensions, Pressable } from "react-native"
import * as SplashScreen from "expo-splash-screen"
import LottieView from "lottie-react-native"
import { BFColors } from "@/constants/Colors"
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withDelay,
  withTiming,
} from "react-native-reanimated"

import {
  $appIsLoading,
  LaunchStateType,
  setLaunchState,
} from "@/stores/appStore"

import { useStore } from "@nanostores/react"
import FullScreenBackgroundGradient from "@/components/backgrounds/FullScreenBackgroundGradient"

const BackflipSplashScreen: React.FC = () => {
  const appIsLoading = useStore($appIsLoading)
  useEffect(() => {
    void SplashScreen.hideAsync()
  }, [])

  const opacity = useSharedValue(0)

  useEffect(() => {
    opacity.value = withDelay(1000, withTiming(1, { duration: 1000 }))
  }, [])

  const animatedStyles = useAnimatedStyle(() => {
    return {
      opacity: opacity.value,
    }
  })

  const handleScreenPress = () => {
    setLaunchState(LaunchStateType.Launched)
  }

  if (appIsLoading) {
    return (
      <Pressable
        testID={"screen-press-area"}
        onPress={handleScreenPress}
        style={[styles.fullScreen]}
      >
        <Animated.View style={[styles.gradientFullScreen, animatedStyles]}>
          <FullScreenBackgroundGradient />
        </Animated.View>

        <View
          style={{
            // opacity: 0.5,
            width: "100%",
            height: "100%",
            backgroundColor: "transparent",
          }}
        >
          <LottieView
            source={require("@/assets/lottie/NewestLogoKS_finalized.json")}
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: "transparent",
            }}
            webStyle={{
              width: Dimensions.get("window").width < 500 ? "100%" : "400px",
              backgroundColor: BFColors.midnightBlue,
            }}
            loop={false}
            autoPlay
            onAnimationFinish={() => {
              handleScreenPress()
            }}
          />
        </View>
      </Pressable>
    )
  }

  return null
}

const styles = StyleSheet.create({
  fullScreen: {
    flex: 1,
    width: "100%",
    height: "100%",
    backgroundColor: BFColors.midnightBlue,
  },
  gradientFullScreen: {
    position: "absolute",
    width: "100%",
    height: "100%",
  },
})

export default BackflipSplashScreen
